import { FETCH_MEASUREMENTS_POINTS } from '#action/types';

const defaultState = [];

export default function (state = defaultState, action) {
  switch (action.type) {
    case FETCH_MEASUREMENTS_POINTS:
      return action.payload;
    default:
      return state;
  }
}
